var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDreams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dreams_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345.33 345.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dreams_svg__linear-gradient",
    x1: 41.99,
    y1: 325.29,
    x2: 213.32,
    y2: 128.68,
    gradientTransform: "matrix(1 0 0 -1 0 348)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2766a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e4d8b"
  })), /*#__PURE__*/React.createElement("style", null, ".dreams_svg__cls-3{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "dreams_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dreams_svg__Color_icons",
    "data-name": "Color icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dreams_svg__Dreams"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#dreams_svg__linear-gradient)"
    },
    d: "M0 0h345.33v345.33H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "m96.72 219.28-2.01-1.62"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dreams_svg__cls-3",
    d: "M239.82 245.44a99.47 99.47 0 1 1-93.25-172.09 101.49 101.49 0 0 0 93.25 172.09ZM242.28 115.06l6.22 28.03 28.03 6.22-28.03 6.22-6.22 28.04-6.22-28.04-28.04-6.22 28.04-6.22 6.22-28.03zM216.61 81.09l2.89 12.29 12.29 2.89-12.29 2.89-2.89 12.29-2.89-12.29-12.28-2.89 12.28-2.89 2.89-12.29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "dreams_svg__cls-3",
    d: "m178.32 98.53 5.67 23.68 23.68 5.67-23.68 5.66-5.67 23.69-5.66-23.69-23.69-5.66 23.69-5.67 5.66-23.68z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDreams);
export default __webpack_public_path__ + "static/media/dreams.6fd11c5e121cc8a525ce2bb2cb99fcef.svg";
export { ForwardRef as ReactComponent };